<template>
  <Loader
    :value="promises.fetch"
    :message="$t('loading', { resource: $metaInfo.title.toLowerCase() }) + '...'"
    class="residential-accounts"
  >
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title"> </HeaderComponent>
      <div class="residential-accounts__content">
        <Card v-for="item in itemsComp" :key="item.id" :value="item" />
      </div>
      <EmptyState v-if="!itemsComp.length && !errors.fetch" :title="$t('noUnits')" :icon="['fal', 'home']" />
    </div>
  </Loader>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeaderComponent from '@/components/Header'
import Card from '@/components/ResidentialAccount/Card'
import EmptyState from '@/components/EmptyState'

export default {
  computed: {
    ...mapState('ResidentialAccount', ['items', 'promises', 'errors']),
    itemsComp() {
      return (this.items || []).sort((a, b) => {
        {
          if (a.status === 'published') {
            return -1
          }

          if (b.status === 'published') {
            return 1
          }

          return 0
        }
      })
    },
  },
  methods: {
    ...mapActions('ResidentialAccount', ['fetch']),
  },
  created() {
    this.fetch()
      .then(() => {
        if (this.items.length > 1) return
        return this.$router.replace({ name: 'residential-account', params: { id: this.items[0].id } })
      })
      .catch(() => this.$router.replace({ name: 'residential-account-login' }))
  },
  metaInfo() {
    return {
      title: this.$t('residentialAccountYourUnits'),
    }
  },

  components: {
    Card,
    HeaderComponent,
    EmptyState,
  },
}
</script>

<style lang="scss">
.residential-accounts {
  background-color: $background-grey;

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: $form-gap;
  }
}
</style>
